import { TICKET_PRIORITIES, type TicketPriority } from '../../types/bpTickets';
import { priorityChipClass } from './statusColors';
import { SELECT_CHEVRON } from './chevron';

/**
 * A chip-styled `<select>` for urgency ("Priority" in Airtable) — same pattern as StatusSelect,
 * coloured via priorityChipClass so Urgent still reads red while editable.
 *
 * No "unknown value" fallback option here, unlike StatusSelect/CategorySelect: those two read
 * genuinely unvalidated Airtable select-option text, which can carry a rename the frontend has
 * never seen. Priority is different — bpTickets.js's ticketPriority() always normalizes it to
 * exactly 'Regular' or 'Urgent' before it ever reaches the frontend, so `priority` here can only
 * ever be one of the two options already in TICKET_PRIORITIES.
 */
export function PrioritySelect({
  priority,
  onChange,
  disabled,
}: {
  priority: TicketPriority;
  onChange: (priority: TicketPriority) => void;
  disabled?: boolean;
}) {
  return (
    <select
      value={priority}
      disabled={disabled}
      onChange={(e) => onChange(e.target.value as TicketPriority)}
      style={{ backgroundImage: SELECT_CHEVRON, backgroundRepeat: 'no-repeat', backgroundPosition: 'right 8px center', backgroundSize: '10px' }}
      className={`appearance-none rounded py-0.5 pl-2 pr-6 text-xs font-regular disabled:opacity-60 ${priorityChipClass(priority)}`}
    >
      {TICKET_PRIORITIES.map((p) => (
        <option key={p} value={p}>
          {p === 'Urgent' ? '⚠️ Urgent' : 'Regular'}
        </option>
      ))}
    </select>
  );
}
